import script from "./step.vue?vue&type=script&setup=true&lang=js"
export * from "./step.vue?vue&type=script&setup=true&lang=js"

import "./step.vue?vue&type=style&index=0&id=3cd7e0d5&lang=less"

const __exports__ = script;

export default __exports__